// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.

import Select from 'react-select-plus'

import 'react-select-plus/dist/react-select-plus.css'
import style from './style.styl'

const SelectWrapper = function(props) {
  const className = style.SelectWrapper
  return <Select {..._.extend({ className }, props)} />
}

SelectWrapper.displayName = 'SelectWrapper'

export default SelectWrapper



// WEBPACK FOOTER //
// ./src/scripts/components/shared/SelectWrapper/index.js